export enum COLOR {
  PRIMARY = "#F5821F",
  RED = "#D6482A",
  BLACK = "#000000",
  GREEN = "#4AC66F",
  WHITE = "#FFFFFF",
  OFF_WHITE = "#EAEAEA",
  LIGHT_BG = "#F5F6FA",
  GRAY = "#ACACAC",
  BUTTON_PRIMARY = "#F58220",
  BUTTON_DISABLED = "#898989",
  DARK_GRAY = "#C7C7C7",
  SHADOW = "#00000029",
  PURPLE = "#434175",
  PRIMARY_GREY = "#A1A1A1",
  LIGHT_ORANGE = "rgba(245, 130, 32, .2)",
}

export enum INPUT_TYPE {
  TEXT = "text",
  NUMBER = "number",
  PASSWORD = "password",
  RADIO = "radio",
  DROPDOWN = "dropdown",
  FILE = "file",
  DATE = "date",
}

export enum StyleType {
  roundedInput = "rounded",
  borderBottomInput = "line",
}

export const CC_EMAIL_ID = "support@myshubhlife.com";
export const imageBaseUrl = "https://www.myshubhlife.com";
export const uatImageBaseUrl = "https://uat.myshubhlife.com";
